import CIcon from '@convenia/components/CIcon'

export default {
  components: {
    CIcon
  },

  inheritAttrs: false,

  data: () => ({
    months: [ 'jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez' ]
  })
}
